import * as React from 'react'
import Collapse from '@material-ui/core/Collapse'
import { StepFlowProps } from './types'
import { getExamplePreviewItems, Tooltip, SvgIcon, FlowFormElement, Title, Grid, Sortable, ADD_ELEMENT_TYPE, ELEMENT_TYPES, FORM_ELEMENT_TYPES } from 'prace-common-components'
import { $FlowContainer, $DropBox, $ConditionIcons, $ElementContainer } from './styles'
import { conditionsToolTips } from 'util/conditionUtils'
import { PreviewFormElement } from './PreviewFormElement'

export const StepFlow: React.FC<StepFlowProps> = ({
  call,
  elements,
  onSelectElement,
  onMove,
  onDrop,
  onEndDrag,
  onDropBox,
  onClickBox,
  selectedIdx = [],
}) => {
  const [collapsedGroups, setCollapsedGroups] = React.useState<Set<number | string>>(
    () => new Set(elements.filter((el) => el.elementType === FORM_ELEMENT_TYPES.GROUP).map((el) => el.id)),
  )

  const toggleGroup = (e: React.MouseEvent, groupId: number | string) => {
    e.stopPropagation()
    setCollapsedGroups((prev) => {
      const next = new Set(prev)
      if (next.has(groupId)) {
        next.delete(groupId)
      } else {
        next.add(groupId)
      }
      return next
    })
  }

  return (
    <$FlowContainer
      container
      direction='column'
      justifyContent='center'
    >
      {/* // TODO: This should not use the order to select */}
      {elements.map((el: FlowFormElement, i: number) =>
        <$ElementContainer
          xs={12}
          key={el.id}
          id={`flow-element-${el.id}`}
          item
          onClick={(e: React.MouseEvent<HTMLDivElement>) => onSelectElement(e, i)}
        >
          <$ConditionIcons>
            {conditionsToolTips(call, el.effects || []).map((conditionTip) => 
              <Tooltip
                key={conditionTip.icon}
                placement='top'
                noIcon
                show
                text={conditionTip.text}
              >
                <div>
                  <SvgIcon color='secondary' name={conditionTip.icon} size='20' />
                </div>
              </Tooltip>,
            )}
            {el.elementType === FORM_ELEMENT_TYPES.PREVIEW ? 
              <Tooltip
                placement='top'
                noIcon
                show
                text='This element previews values of other elements'
              >
                <div>
                  <SvgIcon color='secondary' name='content-copy' size='20' />
                </div>
              </Tooltip>
              : null}
            {el.elementType === FORM_ELEMENT_TYPES.GROUP ? 
              <Tooltip
                placement='top'
                noIcon
                show
                text='This element is a group'
              >
                <div>
                  <SvgIcon color='secondary' name='hive' size='20' />
                </div>
              </Tooltip>
              : null}
          </$ConditionIcons>
          <Sortable
            item={{ id: el.id, type: el.elementType, order: i }}
            type={ELEMENT_TYPES.ELEMENT}
            dropType={[ELEMENT_TYPES.ELEMENT, ADD_ELEMENT_TYPE]}
            selected={selectedIdx.includes(i)}
            onMove={onMove}
            onDrop={onDrop}
            onEndDrag={() => onEndDrag(i)}
            noPointerEvents
          >
            {el.elementType === FORM_ELEMENT_TYPES.GROUP ?
              <Grid container spacing={2}>
                <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <SvgIcon
                    clickable
                    color='secondary'
                    name={collapsedGroups.has(el.id) ? 'chevron-down' : 'chevron-up'}
                    size='20'
                    onClick={(e: React.MouseEvent) => toggleGroup(e, el.id)}
                  />
                  <Title noMargin bold={false} type='group'>{el.title}</Title>
                </Grid>
                <Grid item xs={12} style={{ padding: 0 }}>
                  <Collapse in={!collapsedGroups.has(el.id)}>
                    <Grid container spacing={2} style={{ margin: 0 }}>
                      {el.flow.map(((groupEl: FlowFormElement) =>
                        <$ElementContainer item xs={12} key={groupEl.id}>
                          <$ConditionIcons>
                            {conditionsToolTips(call, groupEl.effects || []).map((conditionTip) =>
                              <Tooltip
                                key={conditionTip.icon}
                                placement='top'
                                noIcon
                                show
                                text={conditionTip.text}
                              >
                                <div>
                                  <SvgIcon color='secondary' name={conditionTip.icon} size='20' />
                                </div>
                              </Tooltip>,
                            )}
                          </$ConditionIcons>
                          <PreviewFormElement
                            whiteBackground
                            element={{// @ts-ignore
                              ...groupEl,
                              type: groupEl.type as ELEMENT_TYPES.ELEMENT,
                              elementType: groupEl.elementType as FORM_ELEMENT_TYPES,
                              //elementProps: { options: groupEl.options },
                              disabled: true,
                            }} />
                        </$ElementContainer>
                      ))}
                    </Grid>
                  </Collapse>
                </Grid>
              </Grid>
              :
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <PreviewFormElement
                    whiteBackground
                    element={{ // @ts-ignore
                      ...el,
                      items: el.items || getExamplePreviewItems(el, call),
                      type: el.type as ELEMENT_TYPES.ELEMENT,
                      elementType: el.elementType as FORM_ELEMENT_TYPES,
                      //elementProps: { options: el.options },
                      disabled: true,
                    }} />
                </Grid>
              </Grid>
            }
          </Sortable>
        </$ElementContainer>,
      )}
      <Grid item>
        <$DropBox type={ADD_ELEMENT_TYPE} onDrop={onDropBox} onClick={onClickBox}>
          Add or edit a form here
        </$DropBox>
      </Grid>
    </$FlowContainer>
  )
}
